import React from "react";

/*
 Child-book style flat illustrations for illiterate users.
 Consistent palette: phone #2F3B52/#EAF6FF, skin #F5C09A, sleeve #3D8BFD,
 coin #FFC93C/#E8A61A, banknote #58B368, wallet #A9713F, green #22A45D, red #E5484D.
*/

/* ===== Welcome: hand drops coin into smiling wallet, arrow up ===== */
export const IlluTopUp = ({ className = "" }) => (
  <svg viewBox="0 0 260 190" className={className} role="img" aria-label="Пополнение кошелька">
    {/* green up arrow */}
    <path d="M30 100 L30 62 L18 62 L40 32 L62 62 L50 62 L50 100 Z" fill="#22A45D" opacity="0.9" />
    {/* sparkles */}
    <g fill="#FFC93C">
      <circle cx="216" cy="96" r="4" />
      <circle cx="236" cy="70" r="3" />
      <circle cx="206" cy="64" r="2.5" />
      <circle cx="70" cy="20" r="3" />
    </g>
    {/* sleeve + hand dropping coin */}
    <rect x="196" y="2" width="64" height="34" rx="14" fill="#3D8BFD" />
    <ellipse cx="186" cy="26" rx="26" ry="17" fill="#F5C09A" />
    <ellipse cx="166" cy="36" rx="11" ry="8" fill="#F5C09A" />
    {/* falling coin */}
    <circle cx="130" cy="56" r="21" fill="#FFC93C" stroke="#E8A61A" strokeWidth="4" />
    <text x="130" y="65" textAnchor="middle" fontSize="24" fontWeight="800" fill="#7A5800">₽</text>
    <line x1="130" y1="84" x2="130" y2="100" stroke="#E8A61A" strokeWidth="5" strokeLinecap="round" strokeDasharray="2 9" />
    {/* coins peeking from slot */}
    <circle cx="112" cy="104" r="12" fill="#FFC93C" stroke="#E8A61A" strokeWidth="3" />
    <circle cx="148" cy="106" r="10" fill="#FFC93C" stroke="#E8A61A" strokeWidth="3" />
    {/* wallet with smiling face */}
    <rect x="66" y="112" width="132" height="70" rx="15" fill="#A9713F" />
    <rect x="66" y="112" width="132" height="22" rx="11" fill="#8A5A2E" />
    <rect x="98" y="106" width="68" height="12" rx="6" fill="#5F3D1E" />
    <circle cx="182" cy="152" r="9" fill="#FFC93C" stroke="#E8A61A" strokeWidth="3" />
    <circle cx="112" cy="150" r="2.5" fill="#5F3D1E" />
    <circle cx="140" cy="150" r="2.5" fill="#5F3D1E" />
    <path d="M112 160 q14 11 28 0" stroke="#5F3D1E" strokeWidth="3.5" fill="none" strokeLinecap="round" />
  </svg>
);

/* ===== Phone step: phone with handset icon + digits, finger tapping ===== */
export const IlluPhone = ({ className = "" }) => (
  <svg viewBox="0 0 240 130" className={className} role="img" aria-label="Введите номер телефона">
    {/* phone */}
    <rect x="78" y="4" width="84" height="122" rx="15" fill="#2F3B52" />
    <rect x="85" y="14" width="70" height="102" rx="9" fill="#EAF6FF" />
    {/* green handset badge */}
    <circle cx="120" cy="38" r="15" fill="#22A45D" />
    <path d="M113 32 c0 -2 2 -4 4 -4 l3 0 c1 2 1.2 4 0.4 6 l-2 1.4 c1 3 3.2 5.2 6.2 6.2 l1.4 -2 c2 -0.8 4 -0.6 6 0.4 l0 3 c0 2 -2 4 -4 4 c-8.5 -0.5 -15 -7 -15.5 -15 z" fill="#fff" />
    {/* digits */}
    <text x="120" y="74" textAnchor="middle" fontSize="19" fontWeight="800" fill="#2F3B52">+7•••</text>
    {/* keypad dots */}
    <g fill="#9DBFD8">
      <circle cx="102" cy="90" r="5" /><circle cx="120" cy="90" r="5" /><circle cx="138" cy="90" r="5" />
      <circle cx="102" cy="105" r="5" /><circle cx="120" cy="105" r="5" /><circle cx="138" cy="105" r="5" />
    </g>
    {/* tapping finger */}
    <rect x="176" y="76" width="62" height="26" rx="13" fill="#F5C09A" />
    <rect x="160" y="80" width="34" height="18" rx="9" fill="#F5C09A" />
    {/* tap ripples */}
    <g stroke="#3D8BFD" strokeWidth="3" strokeLinecap="round" fill="none">
      <path d="M150 72 q4 -6 0 -12" />
      <path d="M156 76 q7 -10 0 -20" />
    </g>
  </svg>
);

/* ===== Amount step: banknotes + coins ===== */
export const IlluMoney = ({ className = "" }) => (
  <svg viewBox="0 0 240 130" className={className} role="img" aria-label="Деньги">
    <g transform="rotate(-8 120 60)">
      <rect x="45" y="26" width="150" height="64" rx="9" fill="#7ACC86" />
    </g>
    <rect x="55" y="40" width="150" height="68" rx="9" fill="#58B368" />
    <rect x="63" y="48" width="134" height="52" rx="6" fill="none" stroke="#3F9153" strokeWidth="3" />
    <circle cx="130" cy="74" r="21" fill="#EDFBEF" />
    <text x="130" y="83" textAnchor="middle" fontSize="26" fontWeight="800" fill="#2F7C43">₽</text>
    {/* coins */}
    <circle cx="48" cy="104" r="17" fill="#FFC93C" stroke="#E8A61A" strokeWidth="4" />
    <text x="48" y="111" textAnchor="middle" fontSize="17" fontWeight="800" fill="#7A5800">₽</text>
    <circle cx="80" cy="112" r="12" fill="#FFC93C" stroke="#E8A61A" strokeWidth="3" />
  </svg>
);

/* ===== QR panel 1: open bank app on phone ===== */
export const IlluBankApp = ({ className = "" }) => (
  <svg viewBox="0 0 120 110" className={className} role="img" aria-label="Откройте приложение банка">
    <rect x="32" y="4" width="56" height="102" rx="11" fill="#2F3B52" />
    <rect x="38" y="13" width="44" height="85" rx="6" fill="#EAF6FF" />
    {/* bank building */}
    <g fill="#3D8BFD">
      <path d="M60 20 L84 34 L36 34 Z" />
      <rect x="41" y="37" width="7" height="22" rx="2.5" />
      <rect x="52" y="37" width="7" height="22" rx="2.5" />
      <rect x="63" y="37" width="7" height="22" rx="2.5" />
      <rect x="74" y="37" width="7" height="22" rx="2.5" />
      <rect x="39" y="62" width="42" height="7" rx="3" />
    </g>
    {/* tap finger */}
    <rect x="72" y="80" width="44" height="20" rx="10" fill="#F5C09A" />
    <rect x="66" y="74" width="20" height="28" rx="10" fill="#F5C09A" />
  </svg>
);

/* ===== QR panel 2: phone camera scanning QR ===== */
export const IlluScanQR = ({ className = "" }) => (
  <svg viewBox="0 0 120 110" className={className} role="img" aria-label="Наведите камеру на QR">
    {/* QR card */}
    <rect x="66" y="24" width="50" height="50" rx="7" fill="#fff" stroke="#CBD5E1" strokeWidth="3" />
    <g fill="#0F172A">
      <rect x="72" y="30" width="13" height="13" rx="2" />
      <rect x="97" y="30" width="13" height="13" rx="2" />
      <rect x="72" y="55" width="13" height="13" rx="2" />
      <rect x="91" y="49" width="6" height="6" />
      <rect x="100" y="57" width="9" height="9" />
      <rect x="91" y="62" width="6" height="6" />
    </g>
    {/* beam */}
    <path d="M50 40 L66 28 L66 72 L50 76 Z" fill="#00B7FF" opacity="0.22" />
    <g stroke="#00B7FF" strokeWidth="3" strokeLinecap="round" strokeDasharray="1 7">
      <line x1="52" y1="46" x2="64" y2="38" />
      <line x1="52" y1="58" x2="64" y2="54" />
      <line x1="52" y1="70" x2="64" y2="68" />
    </g>
    {/* tilted phone */}
    <g transform="rotate(10 28 60)">
      <rect x="8" y="20" width="42" height="78" rx="10" fill="#2F3B52" />
      <rect x="13" y="28" width="32" height="62" rx="5" fill="#EAF6FF" />
      <circle cx="29" cy="38" r="5.5" fill="#2F3B52" />
      <circle cx="29" cy="38" r="2.2" fill="#00B7FF" />
    </g>
  </svg>
);

/* ===== QR panel 3: paid — check + coins into wallet ===== */
export const IlluPaid = ({ className = "" }) => (
  <svg viewBox="0 0 120 110" className={className} role="img" aria-label="Деньги зачислены">
    {/* wallet */}
    <rect x="14" y="60" width="60" height="42" rx="10" fill="#A9713F" />
    <rect x="14" y="60" width="60" height="14" rx="7" fill="#8A5A2E" />
    <circle cx="62" cy="84" r="5.5" fill="#FFC93C" stroke="#E8A61A" strokeWidth="2" />
    <circle cx="32" cy="86" r="1.8" fill="#5F3D1E" />
    <circle cx="46" cy="86" r="1.8" fill="#5F3D1E" />
    <path d="M32 92 q7 6 14 0" stroke="#5F3D1E" strokeWidth="2.5" fill="none" strokeLinecap="round" />
    {/* coins flying in */}
    <circle cx="46" cy="40" r="10" fill="#FFC93C" stroke="#E8A61A" strokeWidth="3" />
    <circle cx="28" cy="24" r="7" fill="#FFC93C" stroke="#E8A61A" strokeWidth="2.5" />
    <line x1="44" y1="52" x2="42" y2="58" stroke="#E8A61A" strokeWidth="3" strokeLinecap="round" />
    {/* green check */}
    <circle cx="88" cy="32" r="23" fill="#22A45D" />
    <path d="M77 32 l8 8 l15 -16" stroke="#fff" strokeWidth="6.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/* ===== Success: big check, sparkles, happy wallet full of coins ===== */
export const IlluSuccess = ({ className = "" }) => (
  <svg viewBox="0 0 260 178" className={className} role="img" aria-label="Оплата прошла успешно">
    <circle cx="130" cy="62" r="52" fill="#22A45D" />
    <path d="M104 62 l18 18 l34 -36" stroke="#fff" strokeWidth="13" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    <g fill="#FFC93C">
      <circle cx="60" cy="28" r="5" />
      <circle cx="202" cy="24" r="4" />
      <circle cx="218" cy="66" r="3" />
      <circle cx="44" cy="70" r="3" />
    </g>
    <circle cx="104" cy="126" r="11" fill="#FFC93C" stroke="#E8A61A" strokeWidth="3" />
    <circle cx="130" cy="121" r="13" fill="#FFC93C" stroke="#E8A61A" strokeWidth="3" />
    <circle cx="156" cy="126" r="11" fill="#FFC93C" stroke="#E8A61A" strokeWidth="3" />
    <rect x="84" y="132" width="92" height="38" rx="11" fill="#A9713F" />
    <circle cx="118" cy="148" r="2.2" fill="#5F3D1E" />
    <circle cx="142" cy="148" r="2.2" fill="#5F3D1E" />
    <path d="M117 156 q13 10 26 0" stroke="#5F3D1E" strokeWidth="3" fill="none" strokeLinecap="round" />
  </svg>
);

/* ===== Failure: big red cross, sad phone, retry arrow ===== */
export const IlluFail = ({ className = "" }) => (
  <svg viewBox="0 0 260 155" className={className} role="img" aria-label="Оплата не прошла">
    <circle cx="130" cy="70" r="52" fill="#E5484D" />
    <g stroke="#fff" strokeWidth="13" strokeLinecap="round">
      <line x1="109" y1="49" x2="151" y2="91" />
      <line x1="151" y1="49" x2="109" y2="91" />
    </g>
    {/* sad phone character */}
    <g transform="translate(198 82)">
      <rect x="0" y="0" width="42" height="64" rx="9" fill="#2F3B52" />
      <rect x="5" y="7" width="32" height="50" rx="5" fill="#EAF6FF" />
      <circle cx="15" cy="26" r="2.5" fill="#2F3B52" />
      <circle cx="27" cy="26" r="2.5" fill="#2F3B52" />
      <path d="M14 41 q7 -8 14 0" stroke="#2F3B52" strokeWidth="3" fill="none" strokeLinecap="round" />
    </g>
    {/* retry circular arrow */}
    <g transform="translate(18 92)">
      <path d="M38 22 a17 17 0 1 1 -9 -15" stroke="#1E88E5" strokeWidth="7" fill="none" strokeLinecap="round" />
      <path d="M24 -2 l14 5 l-9 12 z" fill="#1E88E5" />
    </g>
  </svg>
);

/* ===== Receipt pictogram (small) ===== */
export const IlluReceipt = ({ className = "" }) => (
  <svg viewBox="0 0 60 70" className={className} role="img" aria-label="Чек">
    <path d="M8 4 h44 v58 l-7 -5 l-7 5 l-8 -5 l-8 5 l-7 -5 l-7 5 Z" fill="#fff" stroke="#CBD5E1" strokeWidth="3" strokeLinejoin="round" />
    <circle cx="30" cy="20" r="9" fill="#22A45D" />
    <path d="M26 20 l3 3 l6 -7" stroke="#fff" strokeWidth="2.6" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    <g stroke="#94A3B8" strokeWidth="3" strokeLinecap="round">
      <line x1="16" y1="38" x2="44" y2="38" />
      <line x1="16" y1="46" x2="44" y2="46" />
    </g>
  </svg>
);
